export const baseURLs = {
  //User: 'http://localhost:85',
  User:  process.env.REACT_APP_ADDRESS,
  Admin: process.env.REACT_APP_ADDRESS,
};